const { createContext } = require("react");

export const CartContext = createContext({
    addingPackage: false,
    setAddingPackage: () => {},
    showOverlay: false,
    setShowOverlay: () => {},
    cartData: {},
    setCartData: () => {},
    cartLoading: {},
    setCartLoading: () => {}
});
